import {NgModule} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {TranslateService} from './services/translate.service';
import {TranslatePipe} from "./pipes/translate.pipe";
import {TranslateConfigService} from "./services/translate.config.service";
import {TitleTranslatePipe} from "./pipes/title.translate.pipe";
import {ActionTranslatePipe} from "./pipes/action.translate.pipe";
import {LabelTranslatePipe} from "./pipes/label.translate.pipe";
import {MessageTranslatePipe} from "./pipes/message.translate.pipe";
import {PatientSummaryTranslatePipe} from "./pipes/patient.summary.translate.pipe";
import {FormTranslatePipe} from "./pipes/form.translate.pipe";
import {MultiLineMessageTranslatePipe} from "./pipes/multi.line.message.translate.pipe";



export * from './services/user.context.translate.service';
export * from './services/translate.config.service';
export * from './services/translate.service';
export * from  './services/translate.loader';
export * from './services/translate.static.loader';
export * from './services/missing.translation.handler';
export * from './interfaces/translate.language';
export * from './translate.suffix';
//
// // notice the TranslateLoader and TranslateProxy are provided for the TranslateModule in the root module
@NgModule({
	declarations:[
		TranslatePipe,
		TitleTranslatePipe,
		FormTranslatePipe,
		ActionTranslatePipe,
		LabelTranslatePipe,
		MessageTranslatePipe,
		MultiLineMessageTranslatePipe,
		PatientSummaryTranslatePipe
	],
	exports:[
		TranslatePipe,
		TitleTranslatePipe,
		FormTranslatePipe,
		ActionTranslatePipe,
		LabelTranslatePipe,
		MessageTranslatePipe,
		MultiLineMessageTranslatePipe,
		PatientSummaryTranslatePipe
	]
})
export class CPTranslateModule{
	public static forRoot(){
		return {
			ngModule: CPTranslateModule,
			export:[TranslateModule],
			imports: [
				TranslateModule
			],
			providers: [
				TranslateService,
				TranslateConfigService]
		};
	}
}

